<template>
  <a-locale-provider :locale="locale">
    <div v-if="!isLogin" id="app">
      <div id="components-layout">
        <aside class="layout-sider" :style="siderWidth">
          <div class="logo" :class="{center: isCollapse}">
            <img v-if="!isCollapse" src="./assets/images/btn_logo.png" alt="">
            <img v-else src="./assets/images/logo.png" alt="">
          </div>
          <a-menu
            theme="dark"
            mode="inline"
            @openChange="onOpenChange"
            v-model="selectedKeys"
            :defaultOpenKeys="['0']"
            :defaultSelectedKeys="['0-0']"
            :openKeys="openKeys"
            :inlineCollapsed="isCollapse"
          >
            <a-sub-menu v-for="(item, index) of menuList" :key="`${index}`">
              <span slot="title">
                <a-icon :type="item.icon"/>
                <span>{{item.title}}</span>
              </span>
              <a-menu-item @click="menuClick(el.route, `${index}`, `${index}-${i}`)"
                           v-for="(el, i) of item.subMenu" :key="`${index}-${i}`">
                {{el.title}}
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </aside>

        <main class="layout-main" :style="mainLeft">
          <header :style="headLeft">
            <a-icon class="trigger" :type="isCollapse ? 'menu-unfold' : 'menu-fold'" @click="triggerMenu"/>
            <div class="rt">
              <a-tooltip title="用户信息">
               <span @click="$router.push({name: 'userInfo'})">
                <span class="avatar">
                  <img v-if="userInfo.avatar_url" :src="userInfo.avatar_url" alt="">
                </span>
                <span>{{userInfo.user_name}}</span>
              </span>
              </a-tooltip>
              <a-tooltip title="修改密码">
                <span @click="changePwd"><a-icon type="lock"/></span>
              </a-tooltip>
              <a-tooltip title="退出登录">
                <span @click="logOut"><a-icon type="logout"/></span>
              </a-tooltip>
            </div>
          </header>

          <div class="page-header">
            <a-breadcrumb :routes="breadList">
              <template slot="itemRender" slot-scope="{route, params, routes, paths}">
                <span v-if="breadList.indexOf(route) === breadList.length - 1">{{route.name}}</span>
                <router-link v-else :to="route.path">{{route.name}}</router-link>
              </template>
            </a-breadcrumb>
            <p class="headering">{{breadList[breadList.length - 1].name}}</p>
          </div>

          <section class="layout-content" :style="layoutContent">
            <keep-alive :include="aliveComponent">
              <router-view/>
            </keep-alive>
          </section>

          <footer class="comp-text">
            <img src="./assets/images/icon_haomiao.png" alt="">
            <p>Copyright © 厦门浩邈科技有限公司</p>
          </footer>
        </main>
      </div>
    </div>

    <div :class="{'data-visual': isDataVisual}" v-else>
      <router-view/>
    </div>
  </a-locale-provider>
</template>

<script>
import zhCn from 'ant-design-vue/lib/locale-provider/zh_CN';
import mixin from './js/mixins';
import empty from './js/empty';
import { mapState } from 'vuex';
export default {
  mixins: [mixin.appAuth],
  name: 'App',
  data () {
    return {
      locale: zhCn,
      aliveComponent: [...this.$store.state.componentArr],
      viewRoutes: ['allVis', 'communityVis'],
      fromName: '',
      menuList: [],
      userInfo: {},
      isDataVisual: false,
      isLogin: false,
      isCollapse: false,
      openKeys: ['0'],
      selectedKeys: ['0-0'],
      rootSubmenuKeys: ['0', '1', '2', '3', '4', '5', '6', '7'],
      breadList: []
    };
  },
  watch: {
    $route (to, from) {
      this.fromName = from.name;
      this.$store.state.componentArr.forEach((el) => {
        let noHave = this.aliveComponent.every(item => item !== el);
        if (to.name === el && noHave) {
          this.aliveComponent.push(el);
        }
      });

      this.init();
      this.getBreadcrumb();

      if (['userInfo', 'login'].some(el => el === from.name)) {
        this.setUserData();
      }
    }
  },
  computed: {
    ...mapState({}),
    headLeft () {
      if (this.isCollapse === true) {
        return {width: 'calc(100% - 80px)'};
      } else {
        return {width: 'calc(100% - 250px)'};
      }
    },
    mainLeft () {
      if (this.isCollapse === true) {
        return { paddingLeft: '80px' };
      } else {
        return { paddingLeft: '250px' };
      }
    },
    siderWidth () {
      if (this.isCollapse === true) {
        return {
          flex: '0 0 80px',
          maxWidth: '80px',
          minWidth: '80px',
          width: '80px'
        };
      } else {
        return {
          flex: '0 0 250px',
          maxWidth: '250px',
          minWidth: '250px',
          width: '250px'
        };
      }
    },
    layoutContent () {
      let routeArr = [
        'advancedForm',
        'smartDoor',
        'householdAuthDetail',
        'smartDoorDetail',
        'keyApplyDetail',
        'importRoom',
        'userInfo',
        'memberDetail',
        'pushDetail',
        'noAuth',
        'noPage',
        'auditCompany',
        'addBlackList',
        'priceSet',
        'orderDetail',
        'finance'
      ];
      let isRoute = routeArr.some(el => this.$route.name === el);
      if (isRoute) {
        return {padding: '0px', backgroundColor: 'transparent'};
      }
    }
  },
  created () {
    empty.$on('setCacheData', () => {
      this.clearData();
    });
    empty.$on('setAliveComponent', () => {
      this.aliveComponent.forEach((el, index) => {
        if (el === this.fromName) {
          this.aliveComponent.splice(index, 1);
        }
      });
      localStorage.removeItem('paginationLocal');
    });
    this.getToken();
    this.getBreadcrumb();
    this.init();
    this.setUserData();
  },
  methods: {
    init () {
      let routeArr = ['login', 'forget', 'allVis', 'communityVis'];
      routeArr.some(ele => this.$route.name === ele) ? (this.isLogin = true) : (this.isLogin = false);
      let body = document.getElementsByTagName('body')[0];
      if (this.isLogin === true && this.viewRoutes.some(el => el === this.$route.name)) {
        body.style.backgroundColor = '#060C30';
        this.isDataVisual = true;
      } else {
        body.style.backgroundColor = '#F3F5F8';
        this.isDataVisual = false;
      }

      let menuIndex = sessionStorage.activeIndex && JSON.parse(sessionStorage.activeIndex);
      let activeIndex = this.$store.state.activeIndex;
      if (menuIndex) {
        this.openKeys = menuIndex.openKeys;
        this.selectedKeys = menuIndex.selectedKeys;
      } else if (activeIndex) {
        this.openKeys = activeIndex.openKeys;
        this.selectedKeys = activeIndex.selectedKeys;
      }
    },
    /* 设置用户信息 */
    setUserData () {
      if (localStorage.userInfo) {
        this.userInfo = JSON.parse(localStorage.userInfo);
      }
    },
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    /* 点击修改密码 */
    changePwd () {
      this.$router.push({
        name: 'userInfo',
        query: { param: 'changePwd' }
      });
    },
    /* 退出登录 */
    logOut () {
      this.$post({
        url: '/logout',
        params: {}
      }).then((res) => {
        this.$message.success('退出成功！');
        this.clearData();
      });
    },
    /* 清除数据 */
    clearData () {
      this.openKeys = ['0'];
      this.selectedKeys = ['0-0'];
      this.userInfo = {};
      this.menuList = [];
      this.aliveComponent = [];
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push({name: 'login'});
      location.reload();
    },
    /* 切换菜单折叠 */
    triggerMenu () {
      this.isCollapse = !this.isCollapse;
      this.openKeys = [];
    },
    /* 点击菜单项 */
    menuClick (route, index, key) {
      localStorage.removeItem('paginationLocal');
      this.openKeys = [index];
      this.selectedKeys = [key];
      sessionStorage.activeIndex = JSON.stringify({ openKeys: [index], selectedKeys: [key] });

      this.aliveComponent.forEach((el, index) => {
        if (el === this.$route.name) {
          this.aliveComponent.splice(index, 1);
        }
      });
      if (route === 'allVis') {
        window.open(`${location.protocol}//${location.host}/#/${route}`);
      } else {
        this.$router.push({
          name: route
        });
      }
    },
    /* 创建面包屑 */
    getBreadcrumb () {
      const breadNumber = typeof this.$route.meta.breadNumber !== 'undefined' ? this.$route.meta.breadNumber : 0;
      let query = this.$route.query;
      let newBread;
      if (Object.keys(query).length && query.title) {
        newBread = { name: query.title, path: this.$route.fullPath };
      } else {
        newBread = { name: this.$route.meta.title, path: this.$route.fullPath };
      }
      this.breadList = JSON.parse(localStorage.getItem('breadListStorage')) || [];
      this.breadList.splice(breadNumber, this.breadList.length - breadNumber, newBread);
      localStorage.breadListStorage = JSON.stringify(this.breadList);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue